import { Component } from '@angular/core';
import { ClockComponent } from "./clock/clock.component";
import { UserMenuComponent } from "./user-menu/user-menu.component";
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  imports: [ClockComponent, UserMenuComponent, TranslateModule]
})
export class HeaderComponent {
  protected diaryUrl = environment.diary.url + 'lk/crypto'
}
